const windowScrollLockHandler = (action) => {
  if (action === true) {
    const lockStyles = `height: 100vh; overflow: hidden;`;
    document.body.setAttribute('style', lockStyles);
  } else {
    const unlockedStyles = `overflow-x: hidden;`;
    document.body.setAttribute('style', unlockedStyles);
  }
};

export default windowScrollLockHandler;
